import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../../contexts/ServicesContext';
import type { HrPsychologicalSafetyQuery } from '../../../api/queries';

enum CacheKey {
  HrPsychologicalSafetyOverview = 'HrPsychologicalSafetyOverview',
}

export const useGetHrPsychologicalSafetyOverviewQuery = (
  query?: HrPsychologicalSafetyQuery,
) => {
  const { getHrPsychologicalSafetyOverview } = useServicesContext();

  return useQuery({
    queryKey: [CacheKey.HrPsychologicalSafetyOverview, query],
    queryFn: () => getHrPsychologicalSafetyOverview(query),
    refetchInterval: 60000, // Refetch every minute
  });
};
